<div appFixImagePaths>
  <router-outlet></router-outlet>
  <app-toast-container></app-toast-container>
</div>

<!-- Modal Alert global para toda a aplicação -->
<app-modal-alert></app-modal-alert>

<!-- Modal obrigatório de telefone para login social -->
<app-phone-required-modal></app-phone-required-modal>
